module.exports = __webpack_public_path__ + "static/media/error_animation.81bb259.webm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/error_animation.webm
// module id = wVAw
// module chunks = 9